
export default function WavesIcon() {
return (
    <svg width="34" height="22" viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ICON Waves">
    <path id="Vector 2" d="M0.859375 8.22131V14.279" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 10" d="M32.5713 8.22131V14.279" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 3" d="M4.82373 3.24512L4.82373 19.2547" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 4" d="M8.7876 6.49036L8.7876 16.0096" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 9" d="M28.6069 6.49036L28.6069 16.0096" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 5" d="M12.7515 8.22131L12.7515 14.279" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 6" d="M16.7153 3.24512L16.7153 19.2547" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 7" d="M20.6793 0L20.6793 22.5" stroke="#FF6B6B" stroke-width="1.30769"/>
    <path id="Vector 8" d="M24.6431 3.24512L24.6431 19.2547" stroke="#FF6B6B" stroke-width="1.30769"/>
    </g>
    </svg>
)}